var EdgeLengthComparator = require('./EdgeLengthComparator');

var _SubdivisionStrategy, proto;

_SubdivisionStrategy = function SubdivisionStrategy() {
  this._order = _SubdivisionStrategy.DEFAULT_ORDERING;
};

_SubdivisionStrategy.DEFAULT_ORDERING = new EdgeLengthComparator();
proto = _SubdivisionStrategy.prototype;

proto.getEdgeOrdering = function () {
  return this._order.compare;
};

proto.setEdgeOrdering = function (order) {
  this._order = order;
};

module.exports = _SubdivisionStrategy;